// src/pages/public/Privacy.jsx
// FASE 2.B — P-04 Política de privacidad (pixel-perfect del mockup v4).
// Source: entregable_claude/screens_public.jsx líneas 79-119.
// La prop `go` del mockup se convierte a useNavigate(); go("landing_c") → navigate('/').
import { Helmet } from 'react-helmet-async';
import { PubHead, LegalSection } from './_publicShared';
import { useSmartBack } from '../../auth/useSmartBack';

export default function Privacy() {
  // FIX back-button: useSmartBack respeta history primero, y si entró
  // directo por URL cae al destino correcto según rol/acceso.
  const handleBack = useSmartBack();

  return (
    <div className="mobile-root">
      <Helmet>
        <title>Política de privacidad · Edge Elite</title>
        <meta name="description" content="Política de privacidad de Edge Elite — cómo recolectamos, usamos y protegemos tus datos personales en la plataforma." />
        <link rel="canonical" href="https://edgeelite.cl/privacidad" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Política de privacidad · Edge Elite" />
        <meta property="og:url" content="https://edgeelite.cl/privacidad" />
      </Helmet>

      <section className="screen" style={{ paddingTop: 28, paddingBottom: 60 }}>
        <PubHead back={handleBack} title="Privacidad" />

        <div style={{ marginBottom: 24 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontSize: 24,
              fontWeight: 700,
              letterSpacing: '-0.025em',
              margin: 0,
              marginBottom: 8,
            }}
          >
            Política de privacidad
          </h2>
          <div style={{ fontSize: 12, color: 'var(--muted)' }}>
            Última actualización: <span className="num">15 noviembre 2025</span>
          </div>
        </div>

        <LegalSection n="1" title="Datos que recopilamos">
          Recopilamos: nombre, email, ID de Telegram (solo si conectas tu cuenta), datos de pago
          (procesados por Flow.cl, nunca vemos tu tarjeta) y métricas de uso del producto (qué picks
          abres, cuándo).
        </LegalSection>

        <LegalSection n="2" title="Para qué los usamos">
          Para enviarte alertas, procesar pagos, contactarte por temas de cuenta y mejorar el servicio.{' '}
          <strong style={{ color: 'var(--ink)' }}>Nunca vendemos tus datos a terceros.</strong>
        </LegalSection>

        <LegalSection n="3" title="Comunicaciones">
          Solo te enviamos correos transaccionales (cuenta, pagos, alertas). Las comunicaciones de
          marketing requieren tu consentimiento explícito y puedes desuscribirte en cualquier momento.
        </LegalSection>

        <LegalSection n="4" title="Tus derechos">
          Puedes acceder, modificar o eliminar tus datos en cualquier momento desde Mi cuenta o
          escribiendo a soporte@edgeelite.cl. Tu cuenta y datos se borran de forma permanente al
          cancelar.
        </LegalSection>

        <LegalSection n="5" title="Cookies">
          Usamos cookies esenciales para mantener tu sesión iniciada. No usamos cookies de tracking
          publicitario.
        </LegalSection>

        <LegalSection n="6" title="Almacenamiento">
          Tus datos se guardan en servidores de Firebase (Google Cloud) en EE.UU., bajo cifrado en
          reposo y en tránsito.
        </LegalSection>

        <div
          style={{
            marginTop: 32,
            paddingTop: 20,
            borderTop: '1px solid var(--line)',
            textAlign: 'center',
            fontSize: 13,
            color: 'var(--muted)',
          }}
        >
          contacto@edgeelite.cl
        </div>
      </section>
    </div>
  );
}
